import React from "react";
import ReactTooltip from "react-tooltip";
import { useSelector } from "react-redux";
import {
	getFormValues,
	Field
} from "redux-form";

import {
	Icon,
	ReduxControls
} from "rhombus-react";

import { noop } from "utils/common";
import { EDIT_VERSION_BLADE_FORM } from "forms/list";


const FVS = getFormValues(EDIT_VERSION_BLADE_FORM);

export function ImageEditor(props){
	let currentValues = useSelector(FVS) || {}
		, {
			name,
			cropMetadata,
			openAdjustFramingModal = noop,
		} = props
		, showAdjustFramingModal = false
		;

	if(cropMetadata?.frame?.width && cropMetadata?.frame?.height){
		showAdjustFramingModal = true;
	}

	return (
		<div className="editor image-asset">
			<Field
				name={`${name}.data`}
				label={name}
				component={ReduxControls.Input}
				disabled
			/>
			<Icon name="preview" data-tip data-for={`tooltip-preview-${name}`} />
			<Icon className="bounce-circle"
				name="far fa-cloud"
				data-tip="Select Asset"
				onClick={props.openAssetModal}
			/>
			{showAdjustFramingModal && (
				<Icon
					className="bounce-circle"
					name="far fa-frame"
					data-tip="Adjust Framing"
					onClick={openAdjustFramingModal}
				/>
			)}
			<ReactTooltip id={`tooltip-preview-${currentValues[name]?.name}`} className="variable-preview">
				<img src={currentValues[name]?.prop} alt={currentValues[name]?.name} />
			</ReactTooltip>
		</div>
	);
}

export function VideoEditor(props){
	return (
		<div className="editor video-asset">
			<Field
				name={`${props.name}.data`}
				label={props.name}
				component={ReduxControls.Input}
				disabled
			/>
			<Icon className="bounce-circle"
				name="far fa-cloud"
				data-tip="Select Asset"
				onClick={props.openAssetModal}
			/>
		</div>
	);
}

export function TextEditor(props){
	let { extra } = props
		, nameOptions = {
			name:`${props.name}.data`,
			label:props.name,
			component:ReduxControls.Input,
			type:"textarea",
		}
		;

	if(extra){
		if(extra.tip){
			nameOptions.tip = extra.tip;
		}
		if(extra.required){
			nameOptions.required = extra.required;
		}
		if(extra.charMax){
			nameOptions.charMax = extra.charMax;
			nameOptions.maxLength = extra.charMax;
			nameOptions.showCharCount = true;
		}
	}

	return (
		<div className="editor text-asset">
			<Field {...nameOptions} />
		</div>
	);
}
